export type Token = string | null;

export interface TokenAdapter {
  getAccessToken: () => Promise<Token>;
  setAccessToken: (token: string) => Promise<void>;
  getRefreshToken: () => Promise<Token>;
  setRefreshToken: (token: string) => Promise<void>;
  removeAccessToken: () => Promise<void>;
  removeRefreshToken: () => Promise<void>;
}

export const DEFAULT_ACCESS_TOKEN_KEY = 'hover-access-token';
export const DEFAULT_REFRESH_TOKEN_KEY = 'hover-refresh-token';

export interface LocalStorageTokenAdapterOptions {
  accessTokenKey: string;
  refreshTokenKey: string;
}

export const createLocalStorageAdapter: (
  options: LocalStorageTokenAdapterOptions,
) => TokenAdapter = ({ accessTokenKey, refreshTokenKey }) => ({
  async getAccessToken() {
    return Promise.resolve(localStorage.getItem(accessTokenKey));
  },
  async setAccessToken(token: string) {
    return Promise.resolve(localStorage.setItem(accessTokenKey, token));
  },
  async getRefreshToken() {
    return Promise.resolve(localStorage.getItem(refreshTokenKey));
  },
  async setRefreshToken(token: string) {
    return Promise.resolve(localStorage.setItem(refreshTokenKey, token));
  },
  async removeAccessToken() {
    return Promise.resolve(localStorage.removeItem(accessTokenKey));
  },
  async removeRefreshToken() {
    return Promise.resolve(localStorage.removeItem(refreshTokenKey));
  },
});

export const defaultLocalStorageAdapter = createLocalStorageAdapter({
  accessTokenKey: DEFAULT_ACCESS_TOKEN_KEY,
  refreshTokenKey: DEFAULT_REFRESH_TOKEN_KEY,
});
